import qs from "qs";
import { useLocation } from "react-router-dom";

type QueryParams = { [key: string]: string };

export const useGetQueryParams = (): QueryParams => {
	const { search } = useLocation();

	return qs.parse(search, { ignoreQueryPrefix: true }) as QueryParams;
};
